import { gql } from '@apollo/client';

export const VERIFY_PHONE_NUMBER = gql`
  mutation verifyPhoneNumber($code: String!) {
    verifyPhoneNumber(input: { code: $code })
  }
`;

export const VERIFY_PROMO_CODE = gql`
  mutation verifyPromotionCode($code: String!) {
    verifyPromotionCode(code: $code) {
      name
      code
      active
      amountOff
      percentOff
    }
  }
`;

export const CREATE_TERMS_CONSENT = gql`
  mutation createTermsConsent($viewedTimestamp: DateTime!) {
    createTermsConsent(input: { viewedTimestamp: $viewedTimestamp })
  }
`;

export const CREATE_TRADE_CONFIRMATION_TERMS_CONSENT = gql`
  mutation createTradeConfirmationsConsent {
    createTradeConfirmationsConsent
  }
`;

export const INITIATE_USER_PREFILL = gql`
  mutation initiateUserPrefill {
    initiateUserPrefill {
      redirectUrl
    }
  }
`;

export const VALIDATE_USER_PREFILL = gql`
  mutation validateUserPrefill(
    $firstName: String!
    $lastName: String!
    $email: String!
    $phoneNumber: String!
    $dateOfBirth: DateOfBirth!
    $address: UserAddressInput!
    $ssn: String!
  ) {
    validateUserPrefill(
      input: {
        firstName: $firstName
        lastName: $lastName
        email: $email
        phoneNumber: $phoneNumber
        dateOfBirth: $dateOfBirth
        address: $address
        ssn: $ssn
      }
    )
  }
`;
